import { ChangeDetectionStrategy, Component, NO_ERRORS_SCHEMA, ViewChild } from '@angular/core';
import { DeviceBaseComponent } from '../../device-base/device-base.component';

@Component({
  selector: 'app-polycom-vvx-450',
  templateUrl: './polycom-vvx-450.component.html',
  styleUrls: ['../../device-base/device-base.component.scss'],
  standalone: true,
  imports: [DeviceBaseComponent],
  schemas: [NO_ERRORS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolycomVvx450Component {
  @ViewChild('base') base!: DeviceBaseComponent;

  public readonly buttonsLimit = 12;
}
